import { render, staticRenderFns } from "./projectCount.vue?vue&type=template&id=459a9000&scoped=true&"
import script from "./projectCount.vue?vue&type=script&lang=js&"
export * from "./projectCount.vue?vue&type=script&lang=js&"
import style0 from "./projectCount.vue?vue&type=style&index=0&id=459a9000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a9000",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
